import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import UIIconButton from 'UIComponents/button/UIIconButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import { useSendCrmMessageTopic } from 'crm-message-bus/useSendCrmMessageTopic';
import { trackPreviewDeal } from '../../utils/usageTracker';
import { getIsDealStageView } from '../../selectors/forecastSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const PreviewButton = ({
  dealId
}) => {
  const sendButtonMessage = useSendCrmMessageTopic('PREVIEW_OBJECT');
  const isDealStageView = useSelector(getIsDealStageView);
  const onClickPreview = useCallback(() => {
    trackPreviewDeal(isDealStageView);
    sendButtonMessage({
      objectId: dealId,
      objectTypeId: '0-3'
    });
  }, [isDealStageView, sendButtonMessage, dealId]);
  return /*#__PURE__*/_jsx(UIIconButton, {
    name: "view",
    "data-test-id": `dealname-preview-button`,
    size: "sm",
    use: "tertiary-light",
    tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "frameworkDealTable.preview"
    }),
    onClick: onClickPreview,
    children: /*#__PURE__*/_jsx(UIIcon, {
      name: "view"
    })
  });
};
export default PreviewButton;